let odometerOptions = { auto: false }; // Disables auto-initialization

let Counter = (function() {
    let refresh_time = 20000,
        min_counter_time = 500,
        max_counter_time = 2000,
        max_divisor = 30,
        min_divisor = 15,
        counts,
        updating_counts,
        updating_counters,
        counters_initialized;

    const init = function() {
        counts = {
            session_count: {
                element: '#session_count',
                previous: page_info.total_sessions - 100,
                current: page_info.total_sessions
            },
            therapist_count:{
                element: '#therapist_count',
                previous: page_info.total_therapists - 50,
                current: page_info.total_therapists
            },
            member_count: {
                element: '#member_count',
                previous: page_info.total_members - 10,
                current: page_info.total_members
            }
        }
        on_scroll();
        if (page_info.template !== "redesigned/counselor_application") {
            $(document).on('scroll', on_scroll)
        }
    }

    const update_counts  = function() {
        updating_counts = true;
        let counters_in_view = in_view();
        if (counters_in_view) {
            $.get('/api/main_counters/')
                .success(function (data) {
                    let result = JSON.parse(data);
                    counts['session_count'].current = result.session_count;
                    counts['therapist_count'].current = result.therapist_count;
                    counts['member_count'].current = result.member_count;
                }).always(function () {
                let counters_in_view = in_view();
                if (counters_in_view) {
                    setTimeout(update_counts, refresh_time)
                }
            })
        } else {
            updating_counts = false;
        }
    }

    const update_counters = function() {
        updating_counters = true;
        let counters_in_view = in_view();
        if(counters_in_view) {
            for (let count in counts) {
                let difference = counts[count].current - counts[count].previous;
                if (!!difference) {
                    let divisor = get_random(min_divisor, max_divisor);
                    // This will basically be between 1 and the Math.ceil(difference/min_divisor)
                    // So if the difference is 35 and the min_divisor is 10, this could be any integer from 1 - 4
                    let randomized_difference = Math.ceil(Math.random() * difference / divisor);
                    counts[count].previous += randomized_difference;
                    $(counts[count]['element']).text(counts[count].previous);
                }
            }
            let timeout_time = get_random(min_counter_time, max_counter_time);
            setTimeout(update_counters, timeout_time);
        } else {
            updating_counters = false
        }
    }

    const get_random = function(min, max){
        return min + (Math.random() * (max - min));
    }

    const on_scroll = function() {
        let counters_in_view = in_view();
        let odometer_theme = 'train-station';
        if (page_info.redesigned_home === "betterhelp_two" || page_info.template === "redesigned/counselor_application") {
            odometer_theme = 'default';
        }
        // THIS NEEDS TO BE UPDATED WHEN WE ADD MORE LANGAUGES
        let odometer_format;
        switch (page_info.localizejs_language) {
            case 'en-US':
            case 'en':
                odometer_format = '(,ddd)';
                break;
            case 'fr-FR':
            case 'fr':
                odometer_format = '( ddd),dd';
                break;
            case 'nl-NL':
            case 'nl':
            case 'de-DE':
            case 'de':
                odometer_format = '(.ddd),dd';
                break;
            default:
                odometer_format = '(,ddd)';
        }
        if(counters_in_view && !counters_initialized) {
            $('.counter-number').each(function () {
                const odometer = new Odometer({
                    el: $(this)[0], 
                    value: $(this).text(), 
                    theme: odometer_theme,
                    format: odometer_format,
                });
                odometer.render();
            })
            counters_initialized = true;
        }
        if (counters_in_view && !updating_counts && page_info.template !== "redesigned/counselor_application") {
            update_counts();
        }
        if (counters_in_view && !updating_counters) {
            update_counters();
        }
    }

    const in_view = function () {
        if (page_info.template === "redesigned/counselor_application") {
            return true;
        }
        let page_hidden = document.hidden || document.msHidden || document.webkitHidden || document.mozHidden;
        if (!page_hidden) {
            let viewport_height = $(window).height();
            let counter_offset = $('section.numbers').offset().top;
            let counter_height = $('section.numbers').height();
            let document_position = $(window).scrollTop();

            let viewport_end = document_position + viewport_height;
            let counter_end = counter_offset + counter_height;

            return (document_position <= counter_end && viewport_end >= counter_offset);
        }
    };

    return {
        init: init
    }
})();
